import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl'
import 'react-big-calendar/lib/less/styles.less';
import "react-toggle-switch/dist/css/switch.min.css";
import 'rc-drawer/assets/index.css';
import 'styles/bootstrap.scss'
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import AppLocale from '../lngProvider';
import { NotificationContainer } from 'react-notifications';

import MainApp from 'app/index';
import SignIn from './SignIn';
import {
  setInitUrl,
  fetchUser,
  fetchCompany,
  getUser
} from '../actions/Auth';
import asyncComponent from "util/asyncComponent";

const RestrictedRoute = ({component: Component, ...rest, isLogged}) =>
  <Route
    {...rest}
    render={props =>
      isLogged
        ? <Component {...props} />
        : <Redirect
          to={{
            pathname: '/signin',
            state: {from: props.location}
          }}
        />}
  />;

class App extends Component {

  getUser = () => {
    this.props.getUser();
  };

  componentWillMount() {
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    if (this.props.isLogged) {
      this.props.fetchUser();
      this.props.fetchCompany();
    }
  }


  render() {
    const { match, location, locale, isLogged, initURL, isDirectionRTL} = this.props;
    if (location.pathname === '/') {
      if (!isLogged) {
        return ( <Redirect to={'/signin'}/> );
      } else if (initURL === '' || initURL === '/' || initURL === '/signin') {
        return ( <Redirect to={'/app/dashboard'}/> );
      } else {
        return ( <Redirect to={initURL}/> );
      }
    }

    // for RTL Support
    if (isDirectionRTL) {
      document.body.classList.add('rtl')
    } else {
      document.body.classList.remove('rtl');
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <div className="app-main">
          <Switch>
            <RestrictedRoute path={`${match.url}app`} isLogged={isLogged}
                     component={MainApp}/>
            <Route path='/signin' component={SignIn}/>
            <Route
              component={asyncComponent(() => import('components/Error404'))}/>
          </Switch>
          <NotificationContainer />
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = ({settings, auth}) => {
  const {locale, isDirectionRTL} = settings;
  const {isLogged, authUser, initURL} = auth;
  return { locale, isDirectionRTL, isLogged, authUser, initURL}
};

export default connect(mapStateToProps, {
  setInitUrl,
  fetchUser,
  fetchCompany,
  getUser
})(App);



// WEBPACK FOOTER //
// ./containers/App.js